
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaitonashikcab() {



  const cardData =
  {
    keyword: 'Mumbai To Nashik Cab',
    heading: 'SHREE Tours & Travels: Mumbai To Nashik Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Mumbai to Nashik Cab service, ensuring a smooth and comfortable journey. Whether you are traveling for pilgrimage to Trimbakeshwar Temple, exploring vineyards, or business purposes, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Mumbai to Nashik travel experience.',

    top: 'Top Places to Visit in Nashik  with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "description": "Trimbakeshwar Temple, one of the twelve Jyotirlingas of Lord Shiva, is a highly revered pilgrimage site in India. Located in the town of Trimbak, about 28 km from Nashik, the temple is known for its unique Linga, which represents the three deities – Brahma, Vishnu and Mahesh (Shiva). Pilgrims from across the country visit this temple to perform rituals like Narayan Nagbali and Kalsarpa Shanti. Surrounded by lush green mountains, the temple’s spiritual aura, historic architecture and connection to the sacred Godavari River make it a must-visit."
    },
    {
        "title": "Panchavati",
        "description": "Panchavati is a sacred area in Nashik closely associated with the epic Ramayana. It is believed that Lord Rama, Goddess Sita and Lord Lakshmana spent a significant part of their exile here. Some key attractions in Panchavati include Sita Gufa (a small cave where Sita is said to have stayed), Kalaram Temple (dedicated to Lord Rama with a striking black idol) and Kapaleshwar Temple. The serene surroundings along the banks of the Godavari River make Panchavati a spiritually enriching destination."
    },
    {
        "title": "Sula Vineyards",
        "description": "Sula Vineyards is India’s most famous winery, offering a delightful experience for wine enthusiasts. Located on the outskirts of Nashik, the vineyard provides guided tours where visitors can learn about the winemaking process, enjoy wine tastings and relax at the open-air Sula restaurant overlooking scenic vineyards. The vineyard also hosts the annual Sula Fest, a vibrant music and wine festival. Whether you are a wine lover or just looking for a relaxing getaway, Sula Vineyards is a perfect destination."
    },
    {
        "title": "Anjaneri Hills",
        "description": "Anjaneri Hills, believed to be the birthplace of Lord Hanuman, is a popular trekking destination near Nashik. The trek to Anjaneri Fort is moderately challenging, offering stunning views of the Sahyadri ranges and surrounding valleys. Along the way, trekkers can explore ancient caves, temples and waterfalls. The hill is an important religious site and at the summit, visitors will find the Anjaneri Temple dedicated to Goddess Anjani, the mother of Lord Hanuman."
    },
    {
        "title": "Ramkund",
        "description": "Ramkund is a sacred bathing ghat on the banks of the Godavari River, where devotees take a dip to cleanse their sins. It is believed that Lord Rama used this pond to perform rituals during his exile. The site is particularly significant during the Kumbh Mela, held every 12 years, when millions of pilgrims gather here for holy dips. The ghat is surrounded by temples and offers a peaceful spiritual experience, making it a key pilgrimage site in Nashik."
    },
    {
        "title": "Kalaram Temple",
        "description": "The Kalaram Temple, one of the most important temples in Nashik, is dedicated to Lord Rama. Built in the 18th century, the temple features striking black stone idols of Lord Rama, Goddess Sita and Lord Lakshmana. Its architecture, with intricately carved pillars and an elegant dome, is a testament to the region’s rich heritage. The temple holds immense religious significance and attracts thousands of devotees daily, especially during Ram Navami celebrations."
    },
    {
        "title": "Dudhsagar Falls",
        "description": "Dudhsagar Falls in Nashik (not to be confused with the famous one in Goa) is a beautiful seasonal waterfall located near Someshwar Temple. During monsoon, the falls become a breathtaking sight, resembling a stream of milk cascading down the rocks. The surrounding greenery and peaceful ambiance make it an excellent picnic spot. Visitors can enjoy nature walks, photography and the soothing sounds of flowing water."
    },
    {
        "title": "Pandavleni Caves",
        "description": "The Pandavleni Caves, dating back to the 1st century BC, are a group of ancient Buddhist caves carved into a hillside near Nashik. These caves served as monasteries for Buddhist monks and contain stunning sculptures, inscriptions and prayer halls. Cave 3 and Cave 10 are particularly notable for their intricate carvings. The short trek to the caves offers panoramic views of Nashik city, making it a must-visit spot for history buffs and adventure seekers."
    },
    {
        "title": "Someshwar Temple",
        "description": "Located on the banks of the Godavari River, Someshwar Temple is dedicated to Lord Shiva. Surrounded by lush greenery and peaceful surroundings, the temple is a serene retreat for devotees and tourists. It is also a great place for boating, with scenic views of the river making the experience even more delightful. The temple is especially crowded during the holy month of Shravan when devotees come to offer prayers."
    },
    {
        "title": "Coin Museum",
        "description": "The Coin Museum in Nashik is India’s only museum dedicated to numismatics. Established in 1980, the museum showcases a vast collection of coins from different historical periods, including ancient, medieval and colonial times. It provides insights into India’s economic history, trade practices and coin-making techniques. A visit to this museum is both educational and fascinating for history enthusiasts and collectors."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai to Nashik Taxi",
      "description": "Book a reliable and comfortable taxi from Mumbai to Nashik with SHREE Tours & Travels. Our fleet of well-maintained vehicles and professional drivers ensure a safe and enjoyable journey to Nashik, a popular city known for its religious significance and scenic beauty."
    },
    {
      "name": "Mumbai to Nashik Cab Service",
      "description": "Looking for a dependable Cab service from Mumbai to Nashik? Our service offers a range of vehicles suited to your preferences, ensuring a smooth and comfortable ride with experienced drivers for a hassle-free journey."
    },
    {
      "name": "Mumbai to Nashik One-Way Taxi",
      "description": "Need a one-way taxi from Mumbai to Nashik? Our one-way taxi service ensures an affordable and convenient ride to your destination without worrying about return charges, all with no hidden fees."
    },
    {
      "name": "Mumbai to Nashik Round Trip Cab",
      "description": "Planning a round-trip from Mumbai to Nashik? Our round-trip Cab service offers flexibility in timings and return trips, with well-maintained vehicles and expert drivers, making your journey smooth and comfortable."
    },
    {
      "name": "Affordable Mumbai to Nashik Cab",
      "description": "Get affordable Cab services from Mumbai to Nashik with SHREE Tours & Travels. Our budget-friendly options ensure you travel comfortably without compromising on quality or service. Enjoy a smooth ride at the best prices."
    },
    {
      "name": "Private Taxi for Nashik from Mumbai",
      "description": "For a more personalized and private travel experience, Book a Cab from Mumbai to Nashik. Our private taxi service offers flexibility, comfort and privacy, ensuring you travel according to your schedule."
    },
    {
      "name": "Nashik Temple Tour by Cab",
      "description": "Explore Nashik’s famous temples with our temple tour by Cab service. Visit holy places like the Trimbakeshwar Temple, Saptashrungi and more with a professional driver who will guide you and ensure you have a spiritual and serene experience."
    },
    {
      "name": "Nashik Cab Hire",
      "description": "Hire a Cab from Mumbai to Nashik with ease. We offer a range of vehicles to suit your needs, whether you're traveling solo, with family, or in a group, ensuring a comfortable and safe journey to Nashik."
    },
    {
      "name": "Group Travel from Mumbai to Nashik",
      "description": "Traveling with a group to Nashik? We offer spacious and comfortable Cabs that can accommodate larger groups, making sure everyone travels together comfortably, whether for a religious trip, sightseeing, or family outing."
    },
    {
      "name": "Book Mumbai to Nashik Car",
      "description": "Booking a car from Mumbai to Nashik is easy with SHREE Tours & Travels. Choose from a variety of cars to suit your preferences and travel in comfort and style, whether you're going on a short or long journey."
    },
    {
      "name": "Nashik Cab Booking from Mumbai",
      "description": "Book your Nashik Cab from Mumbai with just a few clicks. Our easy online booking service ensures you can secure your ride in advance for a timely and efficient journey, with a professional driver to guide you along the way."
    },
    {
      "name": "Nashik Sightseeing Tour",
      "description": "Take a sightseeing tour of Nashik with our Cab service. Visit the city's historic temples, picturesque vineyards and scenic locations, with a knowledgeable driver who will ensure you make the most of your trip."
    },
    {
      "name": "Nashik Trip from Mumbai",
      "description": "Embark on a memorable trip from Mumbai to Nashik with SHREE Tours & Travels. Whether you're going for a religious pilgrimage, a sightseeing adventure, or a weekend getaway, our service ensures a comfortable and safe journey."
    },
    {
      "name": "Luxury Nashik Taxi",
      "description": "Experience the best of luxury with our high-end taxi service from Mumbai to Nashik. Choose from a range of luxury vehicles, including SUVs and premium sedans, for an elevated travel experience that combines comfort, style and luxury."
    },
    {
      "name": "Weekend Nashik Trip",
      "description": "Escape the hustle and bustle of Mumbai with a relaxing weekend trip to Nashik. Whether you're looking to explore its temples, vineyards, or just enjoy the peaceful surroundings, our Cab service provides a comfortable and enjoyable ride for your weekend getaway."
    }
  ],
  "tableData": [
    ["- Mumbai to Nashik Taxi", "- Mumbai to Nashik Cab Service"],
    ["- Mumbai to Nashik One-Way Taxi", "- Mumbai to Nashik Round Trip Cab"],
    ["- Affordable Mumbai to Nashik Cab", "- Private Taxi for Nashik from Mumbai"],
    ["- Nashik Temple Tour by Cab", "- Nashik Cab Hire"],
    ["- Group Travel from Mumbai to Nashik", "- Book Mumbai to Nashik Car"],
    ["- Nashik Cab Booking from Mumbai", "- Nashik Sightseeing Tour"],
    ["- Nashik Trip from Mumbai", "- Luxury Nashik Taxi"],
    ["- Weekend Nashik Trip"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Scenic Ride",
      "WhyChoosedescription": "Our Mumbai to Nashik Cab service offers a comfortable and scenic ride. Enjoy the beautiful views of the countryside and cityscape as you travel in our well-maintained, air-conditioned vehicles. Whether you're traveling for business or leisure, we ensure a smooth and enjoyable journey."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Nashik, ensuring a safe and timely journey. They prioritize your safety, comfort and convenience, making sure that you enjoy a smooth and hassle-free ride throughout the trip."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Mumbai to Nashik Cab ride. There are no hidden charges and we provide the best value for money with competitive rates. Whether you need a one-way trip or a round trip, our pricing structure is budget-friendly without compromising on quality."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to ensure optimal performance, safety and comfort. From cleanliness to mechanical checks, we ensure that every vehicle in our fleet is ready for your journey, providing you with a stress-free ride from Mumbai to Nashik."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Nashik Cab with SHREE Tours & Travels is simple and quick. You can book online through our user-friendly platform or reach out to our customer service team for personalized assistance. We make the booking process fast, convenient and hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai to Nashik Cab service. Whether you need an early morning departure or a late-night pickup, our round-the-clock service ensures we are available whenever you need us, accommodating your travel schedule."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are not just skilled drivers; they are also familiar with the local routes and attractions between Mumbai and Nashik. They can offer valuable insights on places to visit, including popular attractions in Nashik and the best spots for dining or sightseeing along the way."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We are committed to delivering excellent service, ensuring that your Mumbai to Nashik Cab ride is comfortable, timely and stress-free. We guarantee a pleasant and memorable travel experience every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a Cab from Mumbai to Nashik?",
        answer: "You can easily book your Mumbai to Nashik Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai to Nashik route?",
        answer: "We offer a variety of vehicles for the Mumbai to Nashik journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai to Nashik inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai to Nashik?",
        answer: "Yes, we offer one-way rental options for your Mumbai to Nashik trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai to Nashik trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai to Nashik Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai to Nashik Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai to Nashik trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai to Nashik?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai to Nashik?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Mumbai to Nashik trip was smooth and comfortable! The driver was friendly and ensured we had a pleasant ride.',
        name: 'Mr. Vishal Kulkarni',
    },
    {
        text: 'I had a wonderful experience with SHREE Tours & Travels. The driver was courteous and I reached Nashik without any hassle.',
        name: 'Miss. Rina Desai',
    }
];












  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai to Nashik Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-to-nashik-cab.jpg",
    "https://shreetoursandtravels.in/img/nashik-tour-cab.jpg"
  ],
  "priceRange": "₹2000 - ₹5000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-to-nashik-cab-service",
    "priceCurrency": "INR",
    "price": 2500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.6,
    "reviewCount": 950
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Karan Joshi"
      },
      "datePublished": "2024-11-10",
      "reviewBody": "A very comfortable trip from Mumbai to Nashik. The driver was very helpful and made sure we had a pleasant journey. Highly recommend!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sonia Sharma"
      },
      "datePublished": "2024-11-20",
      "reviewBody": "The Cab service was smooth and on time. The driver was professional and took good care of us. Would definitely travel again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai to Nashik Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-to-nashik-cab-service"
  },
  "keywords": "Mumbai to Nashik Taxi, Mumbai to Nashik Cab Service, Mumbai to Nashik One-Way Taxi, Mumbai to Nashik Round Trip Cab, Affordable Mumbai to Nashik Cab, Private Taxi for Nashik from Mumbai, Nashik Temple Tour by Cab, Nashik Cab Hire, Group Travel from Mumbai to Nashik, Book Mumbai to Nashik Car, Nashik Cab Booking from Mumbai, Nashik Sightseeing Tour, Nashik Trip from Mumbai, Luxury Nashik Taxi, Weekend Nashik Trip"
};




  return (
    <div>
    <GoogleAnalytics/>
<Helmet>
  <title>Mumbai to Nashik Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai to Nashik Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai to Nashik Taxi, Mumbai to Nashik Cab Service, Mumbai to Nashik One-Way Taxi, Mumbai to Nashik Round Trip Cab, Affordable Mumbai to Nashik Cab, Private Taxi for Nashik from Mumbai, Nashik Temple Tour by Cab, Nashik Cab Hire, Group Travel from Mumbai to Nashik, Book Mumbai to Nashik Car, Nashik Cab Booking from Mumbai, Nashik Sightseeing Tour, Nashik Trip from Mumbai, Luxury Nashik Taxi, Weekend Nashik Trip" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/14.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitonashikcab;